export const chat = [
    {
        content:
            "Chats are the fastest channels of communication with your community. If you want quick feedback, click on appropriate topic, send your message and all your peers will be immediately notified.",
        target: "#nav-Chats",
        placement: "right",
    },
];
